import apiClient from '../api.js';

// Capa de servicios del reporte de becados (`unicen.estudiante_beca`).
// Backend en capas: `UNICEN/modules/economico`.
//
//   GET /economico/becas?id_gestion=&id_sede=
//       -> { data: [ { id_estudiante_beca, unicodigo, cod_carrera, carrera,
//                      estudiante, num_documento, celular, sexo,
//                      plan_economico, tipo_beca, porcentaje, monto,
//                      descuento, resolucion, observacion,
//                      fecha_registro }, ... ] }
//
//       Una fila por beca: un estudiante becado en dos carreras aparece dos
//       veces. `porcentaje` y `monto` son números (una beca usa uno u otro;
//       el que no aplica viene en 0) y `descuento` ya los trae armados
//       ("100 %", "Bs 425"). Los textos vacíos llegan en null.
//
//       400 si falta `id_gestion` o `id_sede`, o no son numéricos.
//
// Solo lectura: asignar o quitar becas sigue en /pagos (Deuda_est.vue).

const resource = '/economico/becas';

const useBecaApi = {
  listarBecados({ id_gestion, id_sede }) {
    return apiClient.get(resource, { params: { id_gestion, id_sede } });
  },
};

export default useBecaApi;
